//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
import "../no/Session.js";
let d=[[],[[[],"Dispose",{},0,0],[["object"],"GetStatus",{R_:{upTodateStatus:''}},1,0],[["objects","undoMarkId"],"MakeUpToDate",{},2,0]],[]];
SPLM.BaseObjectStateManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.BaseObjectStateManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.BaseObjectStateManager.Status = Object.freeze({
    "InvalidUpToDate" : "InvalidUpToDate", "UpToDate" : "UpToDate", "UpToDateToOodParent" : "UpToDateToOodParent", "OutOfDateCannotUpdate" : "OutOfDateCannotUpdate", "Failed" : "Failed", "OutOfDateCanUpdate" : "OutOfDateCanUpdate", "NoState" : "NoState", "UpdateFrozen" : "UpdateFrozen", "ParentNotLoaded" : "ParentNotLoaded", "InterPartAssoBroken" : "InterPartAssoBroken"});

export default SPLM;